import "@formatjs/intl-displaynames/locale-data/es.js";
import {
  CountryCode,
  getCountries,
  getCountryCallingCode,
} from "libphonenumber-js";

export type CountryOption = {
  name: string;
  code: CountryCode;
  dialCode: string;
  flag: string;
};

const regionNames = new Intl.DisplayNames("es", { type: "region" });

function getFlagEmoji(countryCode: CountryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export const countryCodesV2: CountryOption[] = getCountries()
  .map((countryCode) => ({
    name: regionNames.of(countryCode) ?? countryCode,
    code: countryCode,
    dialCode: `+${getCountryCallingCode(countryCode)}`,
    flag: getFlagEmoji(countryCode),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
